module.exports = __webpack_public_path__ + "static/media/logo.1fb13255.png";